// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2774":"be22c9397d39f778","8272":"726eb804d4057c2a","41015":"be22c9397d39f778","71338":"be22c9397d39f778"}[chunkId] + ".css";
};